import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { MechanismSection } from '../components/MechanismSection';
import { WhatYouGetSection } from '../components/WhatYouGetSection';
import { AudienceSection } from '../components/AudienceSection';
import { TransformationSection } from '../components/TransformationSection';
import { FAQSection } from '../components/FAQSection';
import { OfferSection } from '../components/OfferSection';
import { LegalFooter } from '../components/LegalFooter';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
    __fbPixelReady: boolean;
  }
}
export function LandingPage() {
  return <main className="min-h-screen bg-white font-sans text-[#2D1F0E]" data-id="element-187">
      <HeroSection data-id="element-188" />
      <ProblemSection data-id="element-189" />
      <MechanismSection data-id="element-190" />
      <WhatYouGetSection data-id="element-191" />
      <AudienceSection data-id="element-192" />
      <TransformationSection data-id="element-193" />
      <FAQSection data-id="element-194" />
      <OfferSection data-id="element-195" />
      <LegalFooter data-id="element-196" />
    </main>;
}